import {CountUp} from 'countup.js'

export default class NumberCounter {
    constructor(element) {

        this.once = false

        document.addEventListener('scroll', () => {
            if (this.isInViewport(element) && !this.once) {
                this.animate(element);
                this.once = true
            }
        }, {
            passive: true
        });
    }

    isInViewport(el) {
        const rect = el.getBoundingClientRect()

        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    animate(el) {
        const value = el.dataset.number
        const suffix = el.dataset.suffix

        var countUp = new CountUp(el, value, {
            suffix: suffix
        });

        countUp.start()
    }
}